import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './bursa-api-otc-cert.reducer';
import { IBursaAPIOtcCert } from 'app/shared/model/bursa-api-otc-cert.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIOtcCertUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const bursaAPIOtcCertEntity = useAppSelector(state => state.bursaAPIOtcCert.entity);
  const loading = useAppSelector(state => state.bursaAPIOtcCert.loading);
  const updating = useAppSelector(state => state.bursaAPIOtcCert.updating);
  const updateSuccess = useAppSelector(state => state.bursaAPIOtcCert.updateSuccess);
  const handleClose = () => {
    props.history.push('/bursa-api-otc-cert' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...bursaAPIOtcCertEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bursaAPIOtcCertEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="comexApp.bursaAPIOtcCert.home.createOrEditLabel" data-cy="BursaAPIOtcCertCreateUpdateHeading">
            <Translate contentKey="comexApp.bursaAPIOtcCert.home.createOrEditLabel">Create or edit a BursaAPIOtcCert</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bursa-api-otc-cert-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.endpointURL')}
                id="bursa-api-otc-cert-endpointURL"
                name="endpointURL"
                data-cy="endpointURL"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.ecertNo')}
                id="bursa-api-otc-cert-ecertNo"
                name="ecertNo"
                data-cy="ecertNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.memberShortName')}
                id="bursa-api-otc-cert-memberShortName"
                name="memberShortName"
                data-cy="memberShortName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.successYN')}
                id="bursa-api-otc-cert-successYN"
                name="successYN"
                data-cy="successYN"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.msg')}
                id="bursa-api-otc-cert-msg"
                name="msg"
                data-cy="msg"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.seller')}
                id="bursa-api-otc-cert-seller"
                name="seller"
                data-cy="seller"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.buyer')}
                id="bursa-api-otc-cert-buyer"
                name="buyer"
                data-cy="buyer"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.totalValue')}
                id="bursa-api-otc-cert-totalValue"
                name="totalValue"
                data-cy="totalValue"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.currency')}
                id="bursa-api-otc-cert-currency"
                name="currency"
                data-cy="currency"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.price')}
                id="bursa-api-otc-cert-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  min: { value: 0, message: translate('entity.validation.min', { min: 0 }) },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.priceMYR')}
                id="bursa-api-otc-cert-priceMYR"
                name="priceMYR"
                data-cy="priceMYR"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  min: { value: 0, message: translate('entity.validation.min', { min: 0 }) },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.murabahValue')}
                id="bursa-api-otc-cert-murabahValue"
                name="murabahValue"
                data-cy="murabahValue"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.reportingTimeDate')}
                id="bursa-api-otc-cert-reportingTimeDate"
                name="reportingTimeDate"
                data-cy="reportingTimeDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.valueDate')}
                id="bursa-api-otc-cert-valueDate"
                name="valueDate"
                data-cy="valueDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.pName')}
                id="bursa-api-otc-cert-pName"
                name="pName"
                data-cy="pName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.pVolume')}
                id="bursa-api-otc-cert-pVolume"
                name="pVolume"
                data-cy="pVolume"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.supplier')}
                id="bursa-api-otc-cert-supplier"
                name="supplier"
                data-cy="supplier"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIOtcCert.volume')}
                id="bursa-api-otc-cert-volume"
                name="volume"
                data-cy="volume"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/bursa-api-otc-cert" replace>
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BursaAPIOtcCertUpdate;
